import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhCardComponent } from './components/fh-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { FhTextModule } from '@fh-client-interaction-frontends/fh-text';

@NgModule({
  imports: [CommonModule, TranslateModule, FhTextModule],
  declarations: [FhCardComponent],
  exports: [FhCardComponent]
})
export class FhCardModule {}
